import { RefObject, useEffect, useRef } from "react";

export const useElementFirstSeen = (ref: RefObject<HTMLElement>, onSeenCallback?: () => void) => {
    const onSeenCallbackRef = useRef(onSeenCallback);

    useEffect(() => {
        onSeenCallbackRef.current = onSeenCallback;
    });

    useEffect(() => {
        const element = ref.current;

        if (!element || typeof IntersectionObserver === "undefined") {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry?.isIntersecting) {
                    onSeenCallbackRef.current?.();
                    observer.disconnect();
                }
            },
            { threshold: 1.0 }
        );

        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [ref]);
};
